import React from 'react';
import { DeviationDuperbrowseContext } from '../../Duperbrowse';
import GalleryGrid from './_partials/GalleryGrid';
import GalleryTorpedo from './_partials/GalleryTorpedo';
const GalleryView = (props)=>{
    const { deviations, layout } = props;
    return /*#__PURE__*/ React.createElement(DeviationDuperbrowseContext, {
        streamId: deviations.reduce((prev, current)=>`${prev}-${current.deviationId}`, ''),
        deviations: deviations
    }, layout === 'grid' && /*#__PURE__*/ React.createElement(GalleryGrid, props), layout === 'torpedo' && /*#__PURE__*/ React.createElement(GalleryTorpedo, props));
};
GalleryView.displayName = 'GalleryView';
export default GalleryView;

//# sourceMappingURL=GalleryView.js.map